/**
 * Main scripts for Product Display
 * 
 * Handles general functionality for all layouts
 */

(function($) {
    'use strict';

    // WCPS Main Object
    var WCPS = {
        /**
         * Initialize
         */
        init: function() {
            this.initLayouts();
            this.initEvents();
            this.initAjaxFilters();
        },

        /**
         * Initialize Layout Specific Features
         */
        initLayouts: function() {
            // Initialize Grid Layout
            this.initGridLayout();
            
            // Initialize Gallery Layout
            this.initGalleryLayout();
            
            // Initialize Slider Layout
            this.initSliderLayout();
            
            // Initialize Table Layout
            this.initTableLayout();
            
            // Initialize Category Tabs
            this.initCategoryTabs();
        },

        /**
         * Initialize Grid Layout
         */
        initGridLayout: function() {
            // Layout add 08
            $('.wcps-layout-basic-grid').each(function() {
                var $grid = $(this);
                
                // Add equal height to products if needed
                if ($grid.hasClass('equal-height')) {
                    WCPS.equalizeProductHeights($grid.find('.wcps-product'));
                }
                
            });
            $('.wcps-layout-card-grid').each(function() {
                var $grid = $(this);
                
                // Add equal height to products if needed
                if ($grid.hasClass('equal-height')) {
                    WCPS.equalizeProductHeights($grid.find('.wcps-product'));
                }
            });
            $('.wcps-layout-masonry-grid').each(function() {
                var $grid = $(this);
                
                // Add equal height to products if needed
                if ($grid.hasClass('equal-height')) {
                    WCPS.equalizeProductHeights($grid.find('.wcps-product'));
                }
            });

            function getComputedStyle(element, variableName, defaultValue) {
                try {
                    if (!element || !variableName) return defaultValue;
                    const styles = getComputedStyle(element);
                    const value = styles.getPropertyValue(variableName);
                    return value.trim() || defaultValue;
                } catch (e) {
                    console.warn('Failed to get CSS variable:', e);
                    return defaultValue;
                }
            }

            // Responsive 
            $('.wcps-grid-container').each(function() {
                var $container = $(this);
                var updateGridLayout = function() {
                    var windowWidth = $(window).width();
                    var columns;
                    
                    // Determine number of columns based on screen width
                    if (windowWidth <= 480) {
                        columns = 1; // Mobile phones
                    } else if (windowWidth <= 768) {
                        columns = 2; // Tablets
                    } else if (windowWidth <= 1024) {
                        columns = 3; // Small desktops
                    } 
                    else {
                        // Get columns from CSS variable for large desktops
                        var wcpsContainer = $container.closest('.wcps-container')[0];
                        if (wcpsContainer && typeof window.getComputedStyle === 'function') {
                            var columnsValue = window.getComputedStyle(wcpsContainer).getPropertyValue('--wcps-columns');
                            columns = columnsValue ? parseInt(columnsValue.trim()) : 5;
                        } else {
                            columns = 5;
                        }
                    }
                    
                    // Update grid template columns
                    $container.css('grid-template-columns', 'repeat(' + columns + ', 1fr)');
                };
                
                // Initial layout update
                updateGridLayout();
                
                // Update on window resize
                $(window).on('resize', function() {
                    updateGridLayout();
                });
            });
        },

        /**
         * Initialize Gallery Layout with filtering
         */
        initGalleryLayout: function() {
            $('.wcps-layout-gallery').each(function() {
                var $gallery = $(this);
                var $container = $gallery.find('.wcps-gallery-container');
                var $filterBtns = $gallery.find('.wcps-gallery-filter button');
                
                // Initialize isotope if available
                if ($.fn.isotope && $container.length) {
                    $container.imagesLoaded(function() {
                        $container.isotope({
                            itemSelector: '.wcps-gallery-item',
                            percentPosition: true,
                            masonry: {
                                columnWidth: '.wcps-gallery-item'
                            }
                        });
                    });
                    
                    // Filter items on button click
                    $filterBtns.on('click', function() {
                        var filterValue = $(this).attr('data-filter');
                        $container.isotope({ filter: filterValue });
                        $filterBtns.removeClass('active');
                        $(this).addClass('active');
                    });
                } else {
                    // Fallback if isotope isn't available
                    $filterBtns.on('click', function() {
                        var filterValue = $(this).attr('data-filter');
                        $filterBtns.removeClass('active');
                        $(this).addClass('active');
                        
                        if (filterValue === '*') {
                            $container.find('.wcps-gallery-item').show();
                        } else {
                            $container.find('.wcps-gallery-item').hide();
                            $container.find(filterValue).show();
                        }
                    });
                }
            });
        },

        /**
         * Initialize Slider Layout with Slick
         */
        initSliderLayout: function() {
            $('.wcps-layout-slider').each(function() {
                var $slider = $(this);
                var $sliderContainer = $slider.find('.wcps-slider-container');
                console.log('Slider:', $slider.attr('id'), 'Container:', $sliderContainer.length, 'Children:', $sliderContainer.children().length, $sliderContainer.children());
                // Only initialize if there is at least one slide and not already initialized
                if ($.fn.slick && $sliderContainer.length && $sliderContainer.children().length > 0 && !$sliderContainer.hasClass('slick-initialized')) {
                    // Get slider settings
                    var autoplay = $sliderContainer.data('autoplay') === 'yes';
                    var arrows = $sliderContainer.data('arrows') === 'yes';
                    var dots = $sliderContainer.data('dots') === 'yes';
                    var speed = parseInt($sliderContainer.data('speed')) || 3000;
                    var slidesToShow = parseInt($sliderContainer.data('columns')) || 4;
                    
                    // Initialize slick slider
                    $sliderContainer.slick({
                        dots: dots,
                        arrows: arrows,
                        infinite: true,
                        speed: 500,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        autoplay: autoplay,
                        autoplaySpeed: speed,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: Math.min(slidesToShow, 3),
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: Math.min(slidesToShow, 2),
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }
            });
        },

        /**
         * Initialize Table Layout with sorting
         */
        initTableLayout: function() {
            $('.wcps-layout-table').each(function() {
                var $table = $(this);
                var $headers = $table.find('th[data-sort]');
                
                $headers.on('click', function() {
                    var $header = $(this);
                    var sortBy = $header.data('sort');
                    var isAsc = $header.hasClass('asc');
                    
                    // Update header classes
                    $headers.removeClass('asc desc');
                    $header.addClass(isAsc ? 'desc' : 'asc');
                    
                    // Sort table rows
                    var $tableBody = $table.find('tbody');
                    var $rows = $tableBody.find('tr');
                    
                    $rows.sort(function(a, b) {
                        var valA = $(a).find('td[data-' + sortBy + ']').data(sortBy);
                        var valB = $(b).find('td[data-' + sortBy + ']').data(sortBy);
                        
                        if ($.isNumeric(valA) && $.isNumeric(valB)) {
                            valA = parseFloat(valA);
                            valB = parseFloat(valB);
                        }
                        
                        if (isAsc) {
                            return valA > valB ? 1 : valA < valB ? -1 : 0;
                        } else {
                            return valA < valB ? 1 : valA > valB ? -1 : 0;
                        }
                    });
                    
                    // Append sorted rows to table
                    $.each($rows, function(index, row) {
                        $tableBody.append(row);
                    });
                });
            });
        },

        /**
         * Initialize Category Tabs
         */
        initCategoryTabs: function() {
            $('.wcps-layout-category_tabs').each(function() {
                var $tabs = $(this);
                var $tabButtons = $tabs.find('.wcps-tab-buttons .wcps-tab-button');
                var $tabContents = $tabs.find('.wcps-tab-content');
                
                // Handle tab switching
                $tabButtons.on('click', function() {
                    var $button = $(this);
                    var tabId = $button.data('tab');
                    
                    // Update active tab button
                    $tabButtons.removeClass('active');
                    $button.addClass('active');
                    
                    // Show selected tab content
                    $tabContents.removeClass('active');
                    $tabs.find('.wcps-tab-content[data-tab="' + tabId + '"]').addClass('active');
                });
            });
        },

        /**
         * Initialize events for all products
         */
        initEvents: function() {
            // Product hover effects
            $('.wcps-product').hover(
                function() {
                    $(this).addClass('wcps-hover');
                },
                function() {
                    $(this).removeClass('wcps-hover');
                }
            );
        },

        /**
         * Initialize AJAX filtering
         */
        initAjaxFilters: function() {
            // AJAX category filtering
            $('.wcps-ajax-filter').on('click', 'a', function(e) {
                e.preventDefault();
                
                var $this = $(this);
                var $container = $this.closest('.wcps-container');
                var containerId = $container.attr('id');
                var category = $this.data('category');
                
                // Update active filter
                $this.closest('.wcps-ajax-filter').find('a').removeClass('active');
                $this.addClass('active');
                
                // Get product settings from container
                var settings = {
                    layout: $container.data('layout'),
                    columns: $container.data('columns'),
                    show_compare: $container.data('show-compare'),
                    show_wishlist: $container.data('show-wishlist'),
                    show_quickview: $container.data('show-quickview'),
                    show_addtocart: $container.data('show-addtocart'),
                    action_position: $container.data('action-position')
                };
                
                // Show loading
                $container.addClass('wcps-loading');
                
                // Fetch products with AJAX
                $.ajax({
                    url: proddisp_params.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'proddisp_get_products',
                        nonce: proddisp_params.nonce,
                        category: category,
                        settings: settings
                    },
                    success: function(response) {
                        if (response.success) {
                            // Replace products
                            $container.find('.wcps-products-container').html(response.data.html);
                            
                            // Reinitialize features
                            PRODDISP_Features.init();
                            
                            // Reinitialize layout specific features
                            if (settings.layout === 'slider') {
                                WCPS.initSliderLayout();
                            } else if (settings.layout === 'gallery') {
                                WCPS.initGalleryLayout();
                            }
                        }
                        
                        // Remove loading
                        $container.removeClass('wcps-loading');
                    },
                    error: function() {
                        // Remove loading
                        $container.removeClass('wcps-loading');
                    }
                });
            });
        },

        /**
         * Utility function to make product heights equal
         */
        equalizeProductHeights: function($products) {
            var maxHeight = 0;
            
            // Reset heights
            $products.css('height', 'auto');
            
            // Find max height
            $products.each(function() {
                var height = $(this).outerHeight();
                maxHeight = Math.max(maxHeight, height);
            });
            
            // Set all products to max height
            $products.css('height', maxHeight + 'px');
        }
    };

    // Initialize on document ready
    $(document).ready(function() {
        WCPS.init();
    });

    // Re-initialize on window resize
    $(window).on('resize', function() {
        // Debounce resize event
        clearTimeout(window.wcpsResizeTimer);
        window.wcpsResizeTimer = setTimeout(function() {
            // $('.wcps-layout-grid.equal-height').each(function() {
            $('.wcps-layout-basic-grid.equal-height').each(function() {
                WCPS.equalizeProductHeights($(this).find('.wcps-product'));
            });
        }, 250);
    });

    // Make WCPS available globally
    window.WCPS = WCPS;

})(jQuery);